import React, { Component } from "react";
import { push } from "../Services/Analytics"
import { saveVotes } from "../Services/fetchService"
import { switchURLapi } from "../Services/baseURL"
import 'whatwg-fetch'

import ManotRows from "./ManotRows"
import "./ManotSelected.scss"

const apiURLRoot = switchURLapi("http://localhost:60562/api/", "http://source-qa.a.ynet.co.il/mShort/commerce/2018/ManaFalafelAPI/api/", "https://z.ynet.co.il/mShort/commerce/2018/ManaFalafelAPI/api/");

class ManotSelected extends Component {
  constructor() {
    super()
    this.state = {
      isOpened: false,
      busy: false
    }
    this.openOver = this.openOver.bind(this);
    this.sendVotes = this.sendVotes.bind(this);
    this.getManot = this.getManot.bind(this);
  }
  openOver() {
    this.setState({
      isOpened: !this.state.isOpened
    })
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.current == 3) {
      this.setState({
        isOpened: true
      })
    }
  }
  sendVotes() {
    const items = [];
    if (this.props.current == 0) {
      this.props.triggerPopup({
        Title: "יש לבחור 3 פלאפליות",
        Describe: ""
      }, "")
      //alert("לא ניתן לשלוח ללא הצבעות");
      return;
    }
    if (this.props.current != 3) {
      this.props.triggerPopup({
        Title: "יש לבחור 3 פלאפליות",
        Describe: ""
      }, "")
      //alert("יש לבחור 3 פלאפליות");
      return;
    }

    this.props.mealsSelected.forEach(item => {
      items.push(item["ID"])
    });

    if (this.state.busy) {
      return;
    }
    this.props.showLoader();
    this.setState({
      busy: true
    })

    fetch(`${apiURLRoot}save`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(items)
    }).then(data => {
      this.props.triggerPopup({
        Title: "הצבעותיך נשלחו בהצלחה!",
        Describe: ""
      }, "")
      //alert("הצבעתך נרשמה במערכת");
      this.props.showLoader();
      push("Send Vote Clicked", "");

      this.props.mealsSelected.splice(1, 3).forEach((item, index) => {
        this.props.getMeal(item, Math.round(this.props.current - 1))
        this.props.removeSelected(item.ID);
      });

      this.setState({
        busy: false
      })
    });
  }
  getManot() {
    return this.props.mealsSelected.map((item, index) => (index != 0 ?
      <ManotRows key={index}
        index={index}
        current={this.props.current}
        getMeal={this.props.getMeal}
        removeSelected={this.props.removeSelected}
        item={item} />
      : ""))
  }
  render() {
    return (
      <section className={`section section-manotselected${(this.state.isOpened ? " open" : "")}`}>
        <div className="opener" onClick={this.openOver}>
          <div className="text">
            {`${this.props.current}/3`}
          </div>
        </div>
        <div className="padding">
          <div className="container">
            <div className="headline">
              {`בחרת ${this.props.current}/3 פלאפליות:`}
            </div>
            <div className="manot">
              {this.getManot()}
            </div>
            <div className="button" onClick={this.sendVotes}>
              <div className="button-text">
                שלח
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ManotSelected;



// WEBPACK FOOTER //
// ./src/Components/ManotSelected/ManotSelected.js